import { Button, IconButton, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CropLandscapeOutlined, ExpandMore } from '@mui/icons-material';
import DoneIcon from '@mui/icons-material/Done';
import Searchicon from '../../../assets/images/Search.svg';
import { useHook as EquipmentsDashboard } from '../hardware/equipments/useHook';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useHook as UnitHook } from './useHook';
import { setEquipmentDetailsAction } from '../../../stores/actionTypes/equipmentsActions';
  const networkInterfaces=[
    {label:"Wifi",value:"wifi"},
    {label:" Sim Network",value:"sim"}  
  ]
const Create = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editData } = props;
  const { fetchGetAllEquipmentList, fetchGetEquipmentDetails } =
    EquipmentsDashboard();
  const { createUnit, editUnit } = UnitHook();
  const { equipmentAllList, equipmentDetails } = useSelector(
    (state: any) => state.equipments,
  );
  const [open, setOpen] = useState(false);
  const [interfaceOpen,setInterfaceOpen] = useState(false)
  const [selectedInterface,setSelectedInterface] = useState<any>([])

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
  } = useForm({
    defaultValues: {
      serialNumber: '',
      gatewayNo: '',
      category: '',
      subCategory: '',
      unitName: '',
        simNumber: '',
      // category5: '',
    },
  });
  const [filteredEquipmentsData, setFilteredEquipmentsData] =
    useState<any>(equipmentAllList);
  const [selectedEquipmentId, setSelectedEquipmentId] = useState<string>('');
  const [isUnitActive, setIsUnitActive] = useState(false);

  const handleGetAllEquipment = async () => {
    await fetchGetAllEquipmentList();
  };
  useEffect(() => {
    handleGetAllEquipment();
  }, []);
  useEffect(() => {
    setFilteredEquipmentsData(equipmentAllList);
  }, [equipmentAllList]);


useEffect(() => {
  if (editData) {
    setValue('serialNumber', editData.serialNumber);
    setValue('gatewayNo', editData.gatewayNo);
    setValue('category', editData.category);
    setValue('subCategory', editData.subCategory);
    setValue('unitName', editData.unitName);
    setValue('simNumber', editData.simNumber);
    setSelectedEquipmentId(editData.equipmentID);
    setSelectedInterface(editData?.networkInterface === "wifi" ? [{label:"Wifi",value:"wifi"}] : editData?.networkInterface === "sim" ? [{label:" Sim Network",value:"sim"}] : [])
  }
}, [editData]);

  useEffect(() => {
    setValue('category', equipmentDetails.category);
    setValue('subCategory', equipmentDetails.subCategory);
  }, [equipmentDetails]);

  const handleEquipmentSearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: any = equipmentAllList?.filter((equipment: any) =>
      equipment?.equipmentName?.toLowerCase().includes(query),
    );

    setFilteredEquipmentsData(filtered);
  };
  const handleActiveChange = () => {
    setIsUnitActive(true);
  };

  const handleCloseEquipment = () => {
    setOpen(false);
    setFilteredEquipmentsData(equipmentAllList);
  };

    const handleCloseInterface = () => {
    setInterfaceOpen(false);
  
  }

  const handleEquipmentDisplay = async (equipmentId: any) => {
    if (equipmentId && selectedEquipmentId !== equipmentId) {
      getEquipmentDetails(equipmentId);
      setSelectedEquipmentId(equipmentId);
    } else {
      // setSelectedEquipmentId('');
      // dispatch(setEquipmentDetailsAction({}));
    }
    handleCloseEquipment();
    setIsUnitActive(true);
  };
  const getEquipmentDetails = async (equipmentId: string) => {
    await fetchGetEquipmentDetails({ equipmentID: equipmentId });
  };


const submitdata = async (data: any) => {
  if (!editData) {
    const payload = {
      equipmentID: selectedEquipmentId,
      unitName: data.unitName,
      serialNumber: data.serialNumber,
      gatewayNo: data.gatewayNo,
      simNumber: data.simNumber,
      networkInterface: selectedInterface[0].value
    };
    await createUnit(payload);
  } else {
    const payload = {
      unitID: editData.unitID,
      equipmentID: selectedEquipmentId,
      unitName: data.unitName,
      serialNumber: data.serialNumber,
      gatewayNo: data.gatewayNo,
      simNumber: data.simNumber,
      networkInterface: selectedInterface[0].value
    };
    await editUnit(payload);
  }
};

  return (
    <>
      <div className="hardware-equipment">
        <div className="equipment-controller">
          <div className="equipment_controller-header manufactural_create-form">
            <div className="manufactural_create-form-field">
              {/* <h4>Equipment Selected</h4> */}
            </div>
            <div className="equipment-controller_header-select manufactural_create-form-field">
              <Select
                open={open}
                onOpen={() => setOpen(true)}
                onClose={handleCloseEquipment}
                className="equipment_header-select"
                multiple
                displayEmpty
                value={[]}
                renderValue={() => (
                  <div className="selecter_dropdown_placeholder">
                    {selectedEquipmentId?.length === 0 ? (
                      'Select Equipment'
                    ) : (
                      <p>{`${equipmentAllList?.find((equipment: { equipmentID: string }) => equipment?.equipmentID === selectedEquipmentId)?.equipmentName || selectedEquipmentId}`}</p>
                    )}
                  </div>
                )}
                IconComponent={ExpandMore}
              >
                <div className="user_name-popover equipment-header_select-popover manufacture_unit_popover">
                  <div className="user_name-popover-search">
                    <TextField
                      className="user_name-popover-search_input search-input"
                      variant="outlined"
                      placeholder="Select Controller names here"
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <img
                            src={Searchicon}
                            className="search_icon"
                            alt="Search Icon"
                          />
                        ),
                      }}
                      onChange={handleEquipmentSearch}
                    />
                  </div>
                  {filteredEquipmentsData?.map(
                    (
                      equipment: { equipmentID: string; equipmentName: any },
                      index: React.Key | null | undefined,
                    ) => (
                      <Button
                        key={index}
                        onClick={() => {
                          handleEquipmentDisplay(equipment?.equipmentID);
                        }}
                        className={
                          selectedEquipmentId === equipment?.equipmentID
                            ? 'global_audilog_user user_checked'
                            : 'global_audilog_user'
                        }
                      >
                        <div className="global_audilog_user_profile">
                          <p>{`${equipment?.equipmentName}`}</p>
                        </div>
                        {selectedEquipmentId === equipment?.equipmentID && (
                          <IconButton className="iconButton">
                            <DoneIcon className="doneIcon" />
                          </IconButton>
                        )}
                      </Button>
                    ),
                  )}
                </div>
              </Select>
            </div>
          </div>
        

    <div className="equipment_controller-header manufactural_create-form">
            <div className="manufactural_create-form-field">
              <h4>Network Interface</h4>
            </div>
            <div className="equipment-controller_header-select manufactural_create-form-field">
              <Select
                open={interfaceOpen}
                onOpen={() => setInterfaceOpen(true)}
                onClose={handleCloseInterface}
                className="equipment_header-select"
                multiple
                displayEmpty
                value={[]}
                renderValue={() => (
                  <div className="selecter_dropdown_placeholder">
                    {selectedInterface?.length === 0 ? (
                      'Select Network Interface'
                    ) : (
                      <p>{selectedInterface[0]?.label}</p>
                    )}
                  </div>
                )}
                IconComponent={ExpandMore}
              >
                <div className="user_name-popover equipment-header_select-popover manufacture_unit_popover">
                  
                  {networkInterfaces?.map(
                    (
                      networkInterface: { label: string; value: string },
                      index: React.Key | null | undefined,
                    ) => (
                      <Button
                        key={index}
                        onClick={() => {
                             
      
      setSelectedInterface([networkInterface]);
 
    handleCloseInterface();

                        }}
                        className={
                          selectedInterface[0]?.value === networkInterface.value
                            ? 'global_audilog_user user_checked'
                            : 'global_audilog_user'
                        }
                      >
                        <div className="global_audilog_user_profile">
                          <p>{`${networkInterface?.label}`}</p>
                        </div>
                        {selectedInterface[0]?.value === networkInterface.value && (
                          <IconButton className="iconButton">
                            <DoneIcon className="doneIcon" />
                          </IconButton>
                        )}
                      </Button>
                    ),
                  )}
                </div>
              </Select>
            </div>
          </div>
          <div className="equipment_controller-line"></div>



          <form onSubmit={handleSubmit(submitdata)}>
            <div className="equipment_controller-body">
              <div className="manufactural_create-form_container">
                <div className="manufactural_create-form">
                  <div className="manufactural_create-form-field">
                    <h3>Serial Number</h3>
                    <TextField
                      fullWidth
                      id="serialNumber"
                      {...register('serialNumber', { required: true })}
                      error={errors.serialNumber ? true : false}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Remove any character that is not a letter or number
                     const sanitizedValue = value.replace(/[^a-zA-Z0-9_-]/g, '');


                        // Update the input field value manually if invalid characters were removed
                        if (sanitizedValue !== value) {
                          e.target.value = sanitizedValue;
                        }
                        handleActiveChange();
                        clearErrors('serialNumber');
                      }}
                    />
                    {errors.serialNumber && (
                      <span className="text-danger">
                        {' '}
                        serialNumber is required
                      </span>
                    )}
                  </div>
                  <div className="manufactural_create-form-field">
                    <h3>Gateway Number</h3>
                    <TextField
                      fullWidth
                      id="gatewayNo"
                      {...register('gatewayNo', { required: true })}
                      error={errors.gatewayNo ? true : false}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Remove any character that is not a letter or number
                        const sanitizedValue = value.replace(
                          /[^a-zA-Z0-9]/g,
                          '',
                        );

                        // Update the input field value manually if invalid characters were removed
                        if (sanitizedValue !== value) {
                          e.target.value = sanitizedValue;
                        }
                        handleActiveChange();
                        clearErrors('gatewayNo');
                      }}
                    />
                    {errors.gatewayNo && (
                      <span className="text-danger">
                        {' '}
                        gatewayNo is required
                      </span>
                    )}
                  </div>
                  <div className="manufactural_create-form-field">
  <h3>Sim Number</h3>
  <TextField
    fullWidth
    id="simNumber"
    {...register('simNumber', { required: true, maxLength: 32 })}
    error={errors.simNumber ? true : false}
    onChange={(e) => {
      const value = e.target.value;
      // Alphanumeric only, no spaces or special characters, max 32 chars
      const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);

      if (sanitizedValue !== value) {
        e.target.value = sanitizedValue;
      }
      handleActiveChange();
      clearErrors('simNumber');
    }}
  />
  {errors.simNumber?.type === 'required' && (
    <span className="text-danger"> simNumber is required</span>
  )}
  {errors.simNumber?.type === 'maxLength' && (
    <span className="text-danger"> simNumber must be at most 32 characters</span>
  )}
</div>
                </div>
                <div className="manufactural_create-form">
                  <div className="manufactural_create-form-field">
                    <h3>Unit Name</h3>
                    <TextField
                      fullWidth
                      id="unitName"
                      {...register('unitName', { required: true })}
                      error={errors.unitName ? true : false}
                      onChange={() => {
                        handleActiveChange();
                        clearErrors('unitName');
                      }}
                    />
                    {errors.unitName && (
                      <span className="text-danger"> unitName is required</span>
                    )}
                  </div>
                  <div className="manufactural_create-form-field">
                    <h3>Category Name</h3>
                    <TextField
                      disabled={true}
                      fullWidth
                      id="category"
                      {...register('category')}
                      onChange={() => {
                        clearErrors('category');
                      }}
                    />
                  </div>
                </div>
                <div className="manufactural_create-form">
                  <div className="manufactural_create-form-field manufactural_create-singleform-field">
                    <h3>SubCategory Name</h3>
                    <TextField
                      disabled={true}
                      fullWidth
                      id="subCategory"
                      {...register('subCategory')}
                      onChange={() => {
                        clearErrors('subCategory');
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="create_controller_form-submit create_equipment_form-submit">
              <Button
                className="create_controller_form-cancel-btn"
                onClick={() => navigate('/manufacture/production')}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className={
                  selectedEquipmentId?.length === 0 || !isUnitActive
                    ? 'disable_controller-btn'
                    : 'create_controller_form-submit-btn'
                }
                disabled={selectedEquipmentId?.length === 0 || !isUnitActive}
              >
                {editData ? 'Save Changes' : 'Create'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Create;
